import apiClient from './apiClient.js';

export const batchService = {
  /**
   * Get batch by ID
   */
  getBatchById: async (batchId) => {
    const response = await apiClient.get(`/batches/${batchId}`);
    return response.data;
  },

  /**
   * Get all addresses of an NCA campaign for map display
   */
  getCampaignMapAddresses: async (nacCampaignId) => {
    const response = await apiClient.get(
      `/batches/campaign/${nacCampaignId}/map-addresses`
    );
    return response.data;
  },

  /**
   * Update batch status
   */
  updateBatchStatus: async (batchId, status) => {
    const response = await apiClient.patch(`/batches/${batchId}/status`, { status });
    return response.data;
  },

  /**
   * Update batch notes
   */
  updateBatchNotes: async (batchId, notes) => {
    const response = await apiClient.patch(`/batches/${batchId}/notes`, { notes });
    return response.data;
  },

  /**
   * Delete batch (only draft)
   */
  deleteBatch: async (batchId) => {
    const response = await apiClient.delete(`/batches/${batchId}`);
    return response.data;
  },

  /**
   * Send a campaign (N batches) to NCA in a single operation.
   * Body: { appHost, campaignName, batchIds: [string] }
   */
  sendCampaignToNCA: async (shopId, { appHost, campaignName, batchIds }) => {
    const response = await apiClient.post(`/shops/${shopId}/batches/send-campaign`, {
      appHost,
      campaignName,
      batchIds,
    });
    return response.data;
  },

  /**
   * Search N new addresses around a center (a dragged map point or the shop)
   * and APPEND them as a new batch to an EXISTING NCA campaign.
   * Body: { count, appHost, mode?, latitude?, longitude?, searchRadius?,
   *         includeApartments?, onlyApartments?, sortBy?, sortOrder?,
   *         includeUsed?, clientId? }
   */
  addBatchToCampaign: async (shopId, nacCampaignId, opts) => {
    const response = await apiClient.post(
      `/shops/${shopId}/campaign/${nacCampaignId}/add-batch`,
      opts
    );
    return response.data;
  },
};

export default batchService;
